const normalizeApiBaseUrl = (baseUrl: string | undefined): string => {
  if (!baseUrl) return "";
  return baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
};

// VITE_API_BASE_URL is the name the super-admin service uses; VITE_API_HOST is
// kept as a fallback so existing deployments keep working until they migrate.
export const API_HOST = normalizeApiBaseUrl(
  import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_HOST,
);

// Public "request board access" flow on the super-admin service. The OTP is sent
// against the email alone; the full request payload is only submitted once the
// OTP is verified (single call, no separate verify endpoint).
export const BOARD_REQUEST_SEND_OTP_URL = `api/super-admin/public/board-request/send-otp`;
export const BOARD_REQUEST_RESEND_OTP_URL = `api/super-admin/public/board-request/resend-otp`;
export const BOARD_REQUEST_SUBMIT_URL = `api/super-admin/public/board-request`;

// Cloudflare Turnstile site key (public, safe to embed). Cloudflare's published
// "always passes" test key is the default so local/dev works without setup.
export const TURNSTILE_SITE_KEY =
  import.meta.env.VITE_TURNSTILE_SITE_KEY || "1x00000000000000000000AA";

export const buildApiUrl = (path: string): string =>
  `${API_HOST}${path.replace(/^\//, "")}`;
